import { VALIDATION_MESSAGES } from '../core/ValidationMessages';
export function validatePositiveNumber(value, fieldName) {
    if (value <= 0) {
        return {
            isValid: false,
            errors: [VALIDATION_MESSAGES.NUMBER_NOT_POSITIVE(fieldName)],
        };
    }
    return { isValid: true, errors: [] };
}
export function validatePercentage(value, fieldName) {
    if (value < 0 || value > 100) {
        return {
            isValid: false,
            errors: [VALIDATION_MESSAGES.PERCENTAGE_OUT_OF_RANGE(fieldName)],
        };
    }
    return { isValid: true, errors: [] };
}
